import React, { useContext, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { Team } from './Team';
import { EditTeamMember } from './EditTeamMember';

export const TeamIndex = () => {
  return (
    <Switch>
      <Route exact path='/team/add' component={EditTeamMember} />
      <Route exact path='/team/edit/:id' component={EditTeamMember} />
      <Route path='' component={Team} />
    </Switch>
  );
};
